import { defaultValue } from "./default-records";
import Email from "./email";

export { defaultValue };
export default Email;
